import * as React from 'react';
import styled from 'styled-components';

import { MobileWizardProgress } from 'common/components/cookbook/MobileWizardProgress';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { WizardProgress } from 'common/components/cookbook/WizardProgress';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useMatchMedia } from 'common/hooks/useMatchMedia';

const StyledWizardProgress = styled(WizardProgress)`
  margin: 16px 0 48px;
  justify-content: center;
`;

const MobileRoot = styled(Stack)`
  width: 100%;
  margin-bottom: 24px;
`;

const UPLOAD_STAGES = ['upload', 'confirm'] as const;

export type UploadStage = (typeof UPLOAD_STAGES)[number];

type Props = {
  stage: UploadStage;
  setStage: React.Dispatch<React.SetStateAction<UploadStage>>;
};

export const UploadOverrideWizard: React.FC<Props> = ({ stage, setStage }) => {
  const format = useFormatMessage();

  const steps = UPLOAD_STAGES.map((stage) => ({
    stage,
    name: format(`forecasting.upload_override_stage:${stage}`),
    onClick: () => setStage(stage),
  }));

  const currentStepIndex = steps.findIndex((step) => step.stage === stage);
  const current = currentStepIndex + 1;

  const lg = useMatchMedia('lg');
  return lg ? (
    <StyledWizardProgress current={current} steps={steps} />
  ) : (
    <MobileRoot gap="regularXlarge">
      <MobileWizardProgress current={current} total={steps.length} />
      <T.Heading level={2} variant="headline">
        {steps[currentStepIndex]?.name}
      </T.Heading>
    </MobileRoot>
  );
};
